import { createFileRoute } from "@tanstack/react-router";
import { Skeleton } from "@wondermaps/ui";

export const Route = createFileRoute("/$orgSlug/admin")({
  pendingComponent: AdminLayoutSkeleton,
  // Component moved to $orgSlug.admin.lazy.tsx for code splitting
});

function AdminLayoutSkeleton() {
  return (
    <div className="flex h-screen">
      {/* Sidebar skeleton */}
      <div className="hidden md:flex w-60 flex-col border-r bg-background p-4">
        <Skeleton className="h-8 w-32 mb-6" />
        <div className="space-y-2">
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-10 w-full" />
        </div>
      </div>
      {/* Main content skeleton */}
      <main className="flex-1 p-6 overflow-y-auto">
        <Skeleton className="h-10 w-64 mb-6" />
        <div className="grid grid-cols-3 gap-4">
          <Skeleton className="h-32" />
          <Skeleton className="h-32" />
          <Skeleton className="h-32" />
        </div>
      </main>
    </div>
  );
}
